import { Card, PageHeader, PageLayout } from '@ksyos/design-system';
import { ManagerAuthorization } from '@common/enums';
import { FundusScreeningManualImportLogs } from '@frontend/components/pages/fundusScreening/fundusScreeningManualImport/logs/FundusScreeningManualImportLogs';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils';
import { FundusScreeningManualImportForm } from './form/FundusScreeningManualImportForm';

export function FundusScreeningManualImportPage() {
    assertHasAuthorization([ManagerAuthorization.fundusScreeningManualImport]);

    const translate = getSelectedLanguage();

    return (
        <PageLayout>
            <PageHeader title={translate.fundusScreening.manualImport.pageTitle} />
            <Card>
                <Card.Header title={translate.fundusScreening.manualImport.pageSubtitle} />
                <Card.Body>
                    <FundusScreeningManualImportForm />
                </Card.Body>
                <Card.Footer>
                    <FundusScreeningManualImportLogs />
                </Card.Footer>
            </Card>
        </PageLayout>
    );
}
